module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-pricing-guide"
  }, [_c('div', {
    staticClass: "jumbo-wrapper product-guide"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("PRODUCT GUIDE")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    BRICKS, TILES &\n                    "), _c('br'), _vm._v("\n                    ENGRAVING OPTIONS\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("Our colors and sizes are well-suited for any location.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('div', {
    staticClass: "row checkbox-list"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        NO"), _c('br'), _vm._v("\n                        UPFRONT COSTS\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        NO"), _c('br'), _vm._v("\n                        MINIMUM ORDER\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        FREE"), _c('br'), _vm._v("\n                        SHIPPING\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "src": "images/checkbox.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "heading"
  }, [_vm._v("\n                        FREE PERSONALIZED\n                        "), _c('br'), _vm._v("\n                        MARKETING SAMPLE!\n                    ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-area"
  }, [_c('div', {
    staticClass: "body-area-headline"
  }, [_vm._v("BRICKS")]), _vm._v(" "), _c('p', [_vm._v("\n                    Engraved brick pricing is based on your total order quantity per material and size. Pricing includes the cost of material, engraving, and freight within the contiguous United States.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pricing-area-images"
  }, [_c('img', {
    staticClass: "img-responsive desktop",
    attrs: {
      "width": "832",
      "height": "779",
      "src": "images/Pricing-Guide/pricingguide01.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileregred.png",
      "alt": "Regimental Red"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileclaret.png",
      "alt": "Claret Full Range"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobilelandgray.png",
      "alt": "Landmark Gray"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileironspotbrick.png",
      "alt": "Medium Ironspot"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobilemesabi.png",
      "alt": "Mesabi Granite"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-area"
  }, [_c('div', {
    staticClass: "body-area-headline"
  }, [_vm._v("TILES")]), _vm._v(" "), _c('p', [_vm._v("\n                    Engraved tile pricing is based on your total order quantity per material and size. Pricing includes the cost of material, engraving, and freight within the contiguous United States.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pricing-area-images"
  }, [_c('img', {
    staticClass: "img-responsive desktop",
    attrs: {
      "width": "831",
      "height": "518",
      "src": "images/Pricing-Guide/pricingguide02.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileredblend.png",
      "alt": "Red Blend"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileironspottile.png",
      "alt": "Medium Ironspot"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobilemanganese.png",
      "alt": "Manganese"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileabsblkgranite.png",
      "alt": "Absolute Black Granite"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileunivers.png",
      "alt": "Univers Font"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-area"
  }, [_c('div', {
    staticClass: "body-area-headline"
  }, [_vm._v("KEEPSAKE REPLICAS")]), _vm._v(" "), _c('div', {
    staticClass: "pricing-area-images"
  }, [_c('img', {
    staticClass: "img-responsive desktop",
    attrs: {
      "width": "860",
      "height": "194",
      "src": "images/Pricing-Guide/pricingguide03.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobilereplica.png",
      "alt": "Keepsake Replica"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-area"
  }, [_c('div', {
    staticClass: "body-area-headline"
  }, [_vm._v("KEEPSAKE PLAQUES")]), _vm._v(" "), _c('div', {
    staticClass: "pricing-area-images"
  }, [_c('img', {
    staticClass: "img-responsive desktop",
    attrs: {
      "width": "860",
      "height": "194",
      "src": "images/Pricing-Guide/pricingguide04.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobileplaque.png",
      "alt": "Keepsake Plaque"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-area"
  }, [_c('div', {
    staticClass: "body-area-headline"
  }, [_vm._v("SYMBOLS & GREEK CHARACTERS")]), _vm._v(" "), _c('div', {
    staticClass: "pricing-area-images"
  }, [_c('img', {
    staticClass: "img-responsive desktop",
    attrs: {
      "width": "806",
      "height": "131",
      "src": "images/Pricing-Guide/pricingguide05.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobilesymbols.png",
      "alt": "Symbols and Greek Characters"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricing-area"
  }, [_c('div', {
    staticClass: "body-area-headline"
  }, [_vm._v("PROJECT & DONOR LOGOS")]), _vm._v(" "), _c('div', {
    staticClass: "pricing-area-images"
  }, [_c('img', {
    staticClass: "img-responsive desktop",
    attrs: {
      "width": "819",
      "height": "144",
      "src": "images/Pricing-Guide/pricingguide06.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img-responsive mobile",
    attrs: {
      "src": "images/Pricing-Guide/mobilelogos.png",
      "alt": "Project and Donor Logos"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a7cffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/PricingGuide.vue
// module id = SSS8
// module chunks = 1